import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import '../../node_modules/styled-theming/index.js';
import '../../App.css.js';
import { backgroundMain, genericDivStyle } from '../../theme/theme-style.js';
var _excluded = ["hover", "clear", "showBg", "className", "style"];
var Div = styled.div.withConfig({
  displayName: "wrappercomponent__Div",
  componentId: "sc-17d5scb-0"
})(["background-color:", ";", ""], function (props) {
  return props.showBg ? backgroundMain : "";
}, genericDivStyle);
var Wrapper = function Wrapper(_ref) {
  _ref.hover;
  _ref.clear;
  var showBg = _ref.showBg,
    className = _ref.className,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, {
    showBg: showBg,
    style: style,
    className: className
  }, rest.children);
};
export { Wrapper as default };